import { useEffect, useState } from 'react';
import './tableFooter.css';

function TableFooter(props) {
	const [pagenum, setPagenum] = useState(1);
	const {offset, pageRecords, limit, totalRecords, totalPages } = props.footerCounts ;
	
	useEffect(() => {
		offset===0 && setPagenum(1)
	},[offset])
	
	
	const pageHandler = (e) => {
		if(e.target.id==="previous01"){
			setPagenum(pagenum-1);
			props.pageNumber(pagenum-1)
		}
		if(e.target.id==="next01"){
			setPagenum(pagenum+1);
			props.pageNumber(pagenum+1)
		}
	}

	return (
		<div className="content-footer-itmes">
			<div className="content-footer-counter">Viewing {offset}–{pageRecords < limit ? offset + pageRecords : offset +limit } of {totalRecords} results</div>
			<div className="content-footer-stepbtn">
				<button id="previous01" onClick={(e) => pageHandler(e)} disabled={pagenum===1}>Previous</button>
				<button id="next01" onClick={(e) => pageHandler(e)} disabled={pagenum===totalPages}>Next</button>
			</div>
		</div>
	)
}

export default TableFooter;